<template>
  <el-dialog title="度量衡" :visible.sync="dialogVisible" width="700px" :close-on-click-modal="false">
    <div class="measure-dialog-body">
      <!-- 模板类型选择 -->
      <div class="template-selector">
        <span class="label">选择规则</span>
        <el-select v-model="localTemplateId" @change="handleTemplateChange" placeholder="请选择规则">
          <el-option
            v-for="template in templateOptions"
            :key="template.templateId"
            :label="template.templateName"
            :value="template.templateId"
          />
        </el-select>
      </div>

      <!-- 度量衡内容展示 -->
      <div class="measure-content" v-if="currentTemplate">
        <div class="measure-group" v-for="(group, groupIndex) in groupedComps" :key="groupIndex">
          <div v-for="(item, index) in group" :key="index" class="measure-item">
            <template v-if="item.type === 'TEXT'">
              <div style="margin-left: 5px">
                <el-input
                  :style="{ width: item.textRule.isFloat ? '80px' : '160px' }"
                  v-model="localValues[getValueIndex(groupIndex, index)].value"
                  :maxlength="item.textRule.maxLength"
                  :type="item.textRule.isFloat ? 'number' : 'text'"
                  :placeholder="getPlaceholder(item)"
                >
                </el-input>
                <el-select
                  v-if="item.textRule.unit.length"
                  v-model="localValues[getValueIndex(groupIndex, index)].unitValueId"
                  style="width: 80px; margin-left: -1px"
                  @change="handleUnitChange(getValueIndex(groupIndex, index), $event, item.textRule.unit)"
                >
                  <el-option
                    v-for="unit in item.textRule.unit"
                    :key="unit.unitValueId"
                    :label="unit.unitValueName"
                    :value="unit.unitValueId"
                  />
                </el-select>
              </div>
            </template>
            <template v-else-if="item.type === 'OPERATOR'">
              <span class="operator" :key="index">{{ item.operatorRule.operatorValue }}</span>
            </template>
          </div>
        </div>

        <!-- 预览 -->
        <div class="preview">
          <span class="label">预览：</span>
          <span class="preview-value">{{ previewValue || '—' }}</span>
        </div>
      </div>
    </div>

    <div slot="footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="handleConfirm">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'MeasureInfoDialog',
  data() {
    return {
      dialogVisible: false,
      currentTemplate: null,
      localTemplateId: null,
      localValues: [],
      options: {},
      // 父组件传入的 measureTemplates
      measureTemplates: [],
      // 父组件传入的 formData (v)
      formData: null,
    };
  },
  computed: {
    templateOptions() {
      return this.measureTemplates.map(template => ({
        templateId: template.templateId,
        templateName: template.templateName,
      }));
    },
    groupedComps() {
      if (!this.currentTemplate) return [];

      const groups = [];
      let currentGroup = [];

      this.currentTemplate.comp.forEach(item => {
        currentGroup.push(item);
      });

      if (currentGroup.length) {
        groups.push(currentGroup);
      }

      return groups;
    },
    previewValue() {
      if (!this.currentTemplate || !this.localValues.length) return '';

      let value = '';
      this.groupedComps.forEach((group, groupIndex) => {
        if (groupIndex > 0) value += '+';

        let groupValue = '';
        group.forEach((item, index) => {
          if (item.type === 'TEXT') {
            const valueIndex = this.getValueIndex(groupIndex, index);
            const currentValue = this.localValues[valueIndex] || {};

            if (item.textRule.unit.length) {
              const unit = item.textRule.unit.find(u => u.unitValueId === currentValue.unitValueId);
              groupValue += (currentValue.value || '') + (unit?.unitValueName || '');
            } else {
              groupValue += currentValue.value || '';
            }
          } else if (item.type === 'OPERATOR') {
            groupValue += item.operatorRule.operatorValue;
          }
        });
        value += groupValue;
      });

      return value;
    },
  },
  methods: {
    /**
     * 打开弹窗
     * @param {Object} options
     * @param {Array} options.measureTemplates - 度量衡模板列表
     * @param {Object} options.formData - 规格值数据对象 (v)
     */
    method_open(options) {
      this.options = options || {}
      this.measureTemplates = options.measureTemplates;
      this.formData = options.formData;

      // 恢复已保存的度量衡数据
      const saved = this.formData.extendValues?.kuaishouMeasureInfo;
      if (saved && saved.templateId) {
        this.localTemplateId = saved.templateId;
        this.currentTemplate = this.measureTemplates.find(t => t.templateId === saved.templateId);
        this.localValues = saved.value ? JSON.parse(JSON.stringify(saved.value)) : [];
      } else {
        // 没有历史数据，选第一个模板
        this.localTemplateId = this.measureTemplates[0]?.templateId;
        this.currentTemplate = this.measureTemplates[0];
        this.localValues = [];
      }

      this.dialogVisible = true;
    },
    handleClose(){
      this.dialogVisible = false
    },
    handleTemplateChange(templateId) {
      this.currentTemplate = this.measureTemplates.find(t => t.templateId === templateId);
      this.localValues = [];
      this.$nextTick(() => {
        this.initLocalValues();
      });
    },

    getPlaceholder(item) {
      if (item.textRule.isFloat) {
        return '请输入数量';
      }
      return '品名';
    },

    getValueIndex(groupIndex, index) {
      let valueIndex = 0;
      for (let i = 0; i < groupIndex; i++) {
        valueIndex += this.groupedComps[i].length;
      }
      valueIndex += index;

      if (!this.localValues[valueIndex]) {
        const currentItem = this.groupedComps[groupIndex][index];
        this.$set(this.localValues, valueIndex, {
          value: '',
          unitValueId: currentItem.type === 'TEXT' ? currentItem.textRule.unit[0]?.unitValueId || '' : '',
          unitValueName: currentItem.type === 'TEXT' ? currentItem.textRule.unit[0]?.unitValueName || '' : '',
          type: currentItem.type,
          textRule: currentItem.textRule,
          operatorRule: currentItem.operatorRule,
        });
      }
      return valueIndex;
    },

    initLocalValues() {
      if (!this.currentTemplate) return;

      const values = [];
      let totalFields = 0;

      // 尝试从已保存的数据中恢复
      const savedData = this.formData.extendValues?.kuaishouMeasureInfo?.value || [];
      this.groupedComps.forEach(group => {
        group.forEach(item => {
          const savedItem = savedData[totalFields] || {};
          values[totalFields] = {
            value:  item.type === 'OPERATOR' ? item?.operatorRule?.operatorValue : savedItem.value || '',
            unitValueId: item.type === 'TEXT' ? savedItem.unitValueId || item.textRule.unit[0]?.unitValueId || '' : '',
            unitValueName: item.type === 'TEXT' ? savedItem.unitValueName || item.textRule.unit[0]?.unitValueName || '' : '',
            type: item.type,
            textRule: item.textRule,
            operatorRule: item.operatorRule,
          };
          totalFields++;
        });
      });

      this.localValues = values;
    },
    handleUnitChange(valueIndex, unitValueId, units) {
    const selected = units.find(u => u.unitValueId === unitValueId);
      this.$set(this.localValues[valueIndex], 'unitValueName', selected?.unitValueName || '');
    },

    handleConfirm() {
      // 先校验必填
      for (let i = 0; i < this.localValues.length; i++) {
        const item = this.localValues[i];
        if (item.type === 'OPERATOR') continue;
        if (!item.value) {
          this.$message.warning('请填写所有度量衡项值');
          return;
        }
        const hasUnit = item.textRule?.unit?.length > 0;
        if (hasUnit && !item.unitValueId) {
          this.$message.warning('请选择所有度量衡单位');
          return;
        }
      }

      // 构建 kuaishouMeasureInfo 数据结构
      const syncValues = this.localValues.map(item => ({
        type: item.type,
        value: item.value || '',
        unitValueId: item.unitValueId || '',
        unitValueName: item.unitValueName || '',
      }));

      const result = {
        value: this.previewValue,
        kuaishouMeasureInfo: {
          templateId: this.localTemplateId,
          value: syncValues,
        },
      };
      this.dialogVisible = false;
      // 通过事件将数据交给父组件处理
      this.options.okFn && this.options.okFn(result)
    },
  },
};
</script>

<style lang="scss" scoped>
.measure-dialog-body {
  .template-selector {
    display: flex;
    align-items: center;
    margin-bottom: 20px;

    .label {
      width: 70px;
      flex-shrink: 0;
      font-size: 14px;
      color: #606266;
    }
  }

  .measure-content {
    .measure-group {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      margin-bottom: 12px;

      &:last-child {
        margin-bottom: 0;
      }
    }

    .measure-item {
      display: inline-flex;
      align-items: center;
      margin: 0 4px 10px;
    }

    .operator {
      margin: 0 6px;
      font-weight: bold;
      font-size: 16px;
      color: #303133;
    }

    .preview {
      margin-top: 16px;
      padding-top: 12px;
      border-top: 1px solid #ebeef5;
      font-size: 13px;
      color: #606266;

      .label {
        font-weight: 500;
      }

      .preview-value {
        color: #303133;
      }
    }
  }
}
</style>
